import { useState, useEffect } from "react";

export const useIsAdmin = () => {
  const [isAdmin, setIsAdmin] = useState(
    () => sessionStorage.getItem("isAdmin") === "true",
  );

  useEffect(() => {
    const check = () =>
      setIsAdmin(sessionStorage.getItem("isAdmin") === "true");

    check();

    window.addEventListener("storage", check);
    window.addEventListener("adminLoginChange", check);
    window.addEventListener("sessionExpired", check);

    const interval = setInterval(check, 1000);

    return () => {
      window.removeEventListener("storage", check);
      window.removeEventListener("adminLoginChange", check);
      window.removeEventListener("sessionExpired", check);
      clearInterval(interval);
    };
  }, []);

  return isAdmin;
};
